module.exports = __webpack_public_path__ + "static/media/00.03b18497.png";